// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import { maxLengthAttr } from "@plumberssupply/XDL/Utilities";
import { FormField, FormState } from "@plumberssupply/XDL/Utilities/form";

export interface AccountFormState extends FormState {
    fields: {
        userFirstLastName: FormField<string>;
        Email: FormField<string>;
        Phone: FormField<string>;
        accountName: FormField<string>;
        accountNumber: FormField<string>;
        Address: FormField<string>;
        branch: FormField<string>;
        applyForPurchasable: FormField<boolean>;
    };
}

export const initialAccountFormState: AccountFormState = {
    isValid: false,
    isSubmitted: false,
    fields: {
        userFirstLastName: {
            value: "",
            validators: ["required", "text"],
            attrs: {
                id: "createAccount_firstName",
                name: "Your First & Last Name",
                label: translate("Your First & Last Name"),
                placeholder: translate("Your First & Last Name"),
                required: true,
                maxLength: 80,
            },
        },
        Email: {
            value: "",
            validators: ["required", "email"],
            attrs: {
                type: "email",
                name: "Email",
                id: "createAccount_email",
                placeholder: translate("Your Email"),
                required: true,
                maxLength: 75,
            },
        },
        Phone: {
            value: "",
            validators: state => {
                return state.fields.applyForPurchasable.value ? ["required", "phone"] : [];
            },
            attrs: {
                id: "createAccount_phoneNumber",
                name: "Phone",
                label: translate("Phone Number"),
                placeholder: "( ___ ) ___ - ____",
                required: true,
                maxLength: maxLengthAttr.phone,
            },
        },
        accountName: {
            value: "",
            validators: state => {
                return state.fields.applyForPurchasable.value ? ["required", "text"] : [];
            },
            attrs: {
                id: "createAccount_accountName",
                name: "Your current Account name",
                label: translate("Plumber's Supply account name"),
                placeholder: translate("Account name"),
                required: true,
            },
        },
        accountNumber: {
            value: "",
            attrs: {
                id: "createAccount_accountNumber",
                name: "Your current account number (if known)",
                label: translate("Plumber's Supply account number (if known)"),
                placeholder: translate("Account number"),
                required: false,
            },
        },
        Address: {
            value: "",
            validators: state => {
                return state.fields.applyForPurchasable.value ? ["required", "text"] : [];
            },
            attrs: {
                id: "createAccount_address",
                name: "Address",
                label: translate("Address on file"),
                placeholder: translate("Address on file"),
                required: true,
            },
        },
        branch: {
            value: "",
            validators: state => {
                return state.fields.applyForPurchasable.value ? ["required"] : [];
            },
            attrs: {
                id: "createAccount_branch",
                name: "branch",
                label: translate("Which branch do you normally do business with?"),
                placeholder: translate("Branch"),
                required: true,
            },
        },
        applyForPurchasable: {
            value: true,
            validators: [],
            attrs: {
                id: "createAccount_applyForPurchasable",
                name: "applyForPurchasable",
                label: translate("Confirm Password"),
                placeholder: translate("Confirm Password"),
                required: true,
            },
        },
    },
};

export interface NewAccountState extends FormState {
    fields: {
        userFirstLastName: FormField<string>;
        Email: FormField<string>;
    };
}
